import CryptoConvert from 'crypto-convert';

const convert = new CryptoConvert();
export { convert };
